import React from 'react';
import Header from '../components/Cattle-feed/Header';
import ListItem from '../components/ListItem';
import { data } from '../HorseData/ProductsForHorses';
import Footer from '../components/Cattle-feed/Footer';

export default function PoultryList() {
  return (
    <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
      <Header />
      {data
        .filter(i => i.type === 'poultry')
        .map(poultry => {
          return (
            <ListItem
              name={poultry.name || 'No Name'}
              description={poultry.description || 'No Description'}
              ingredientValues={poultry.ingredientValues || 'No Ingredient Values'}
              image={poultry.image}
              id={poultry.id}
            />
          );
        })}
      <Footer />
    </div>
  );
}
